
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/c/blog-posts/what-is-curipod-premade-curriculum-aligned-writing-practice",
      function () {
        return require("private-next-pages/c/blog-posts/what-is-curipod-premade-curriculum-aligned-writing-practice.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/c/blog-posts/what-is-curipod-premade-curriculum-aligned-writing-practice"])
      });
    }
  